// <NotPermitted> — canonical ClientHub kit component (Epic 1 · S1.8).
// The "you may not see this" state, deliberately DISTINCT from the success
// empty state ("nothing needs you" / "no time logged"). A gated feed renders
// this, never the empty state. null = "you may not see this" (00_CONTRACT §6).
import React from "react";
import { tintClasses } from "../../shared/tints";

/**
 * @param {object} props
 * @param {string} [props.message]   Defaults to the hub's access-denied line.
 * @param {string} [props.title]     Optional heading (Effort renders "Not permitted").
 * @param {"warm"|"cool"|"positive"} [props.tint="cool"]
 */
export default function NotPermitted({
  message = "You don't have access to this view.",
  title,
  tint = "cool",
}) {
  const t = tintClasses(tint);
  return (
    <div
      role="note"
      className={`rounded-xl border ${t.surface} p-8 text-center`}
    >
      {title && (
        <p className={`text-sm font-semibold ${t.text}`}>{title}</p>
      )}
      <p className={`mt-1 text-sm ${t.text} opacity-80`}>{message}</p>
    </div>
  );
}
